import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { deleteToken, useAppContext } from "utils/store";

export default function BoardLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    store: { userAuthority, userName },
    dispatch,
  } = useAppContext();
  const links = [
    { path: "/board/system", text: "시스템 공지사항" },
    { path: "/board/notice", text: "게시판" },
  ];

  const getClassName = (path) => {
    return `item_dept ${location.pathname.startsWith(path) ? "now" : ""}`;
  };

  const handleSetting = () => {
    navigate("/user-account/");
  };

  const handleLogout = () => {
    if (window.confirm("로그아웃하시겠습니까?")) {
      dispatch(deleteToken());
      navigate("/");
    }
  };

  return (
    <>
      <div class="wrap_dept">
        <div class="top_dept">
          <p class="user">{userName}</p>
          <div class="wrap_contr">
            <button class="set_contr" onClick={() => navigate("/")}>
              <i class="x-icon"></i>
            </button>
            <button class="set_contr" onClick={handleSetting}>
              <i class="x-icon"></i>
            </button>
            <button class="set_contr" onClick={handleLogout}>
              <i class="x-icon"></i>
            </button>
          </div>
        </div>
        <div class="divi"></div>
        <div class="btm_dept">
          <p class="title_dept">커뮤니티</p>
          <div class="nav_dept">
            {links.map((link) => (
              <Link
                key={link.path}
                className={getClassName(link.path)}
                to={link.path}
              >
                {link.text}
              </Link>
            ))}
          </div>
        </div>
      </div>
      {children}
    </>
  );
}
